/* global require */
import i18next from 'i18next';
import markdownJsx from 'i18next-markdown-jsx-plugin';

i18next
  .use(markdownJsx)
  .init({
    lng: 'en',
    resources: require('~/src/locales/en.json'),
  });

// Options (default is JSX):
// t('Unknown Key') - will return a JSX object with "Unknown Key" as content
// t('knownKey') - will return JSX with the value found in en.json
// t('knownKey', {}) - will return only the string (no JSX) found in en.json

export default function t(key: string | string[], options: Object = { postProcess: 'markdown-jsx' }) {
  if (process.env.NODE_ENV === 'test') { // eslint-disable-line
    if (key === i18next.t(key, options)) {
      throw `${key.toString()} is not translated`;
    }
  }

  return i18next.t(key, options);
}
